import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import LocationService from './utils/LocationService';
import { Provider } from 'react-redux';
import store from './store';
import { initializeAuth } from './utils/authInit';
import { clearAuthState } from './utils/tokenUtils';

// Initialize location service at app startup
LocationService.getLocation().catch(() => {
  // Silent fail - service will use defaults
});

// Initialize authentication state from localStorage
initializeAuth(store);

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Root element not found');
}

const root = ReactDOM.createRoot(rootElement);
root.render(
  <Provider store={store}>
    <App />
  </Provider>
);

reportWebVitals();
